import { render, staticRenderFns } from "./SpaceSwitchCard.vue?vue&type=template&id=4bdd53dc"
import script from "./SpaceSwitchCard.vue?vue&type=script&lang=js"
export * from "./SpaceSwitchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports